var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"copyright__link",attrs:{"target":"_blank","href":'https://app.longboat.com/gateway/privacy?locale=' + _vm.locale}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }